/**
* @Author: zachalam
* @Date:   2017-03-21T14:48:57-07:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-03-21T14:48:57-07:00
*/

import map from 'lodash/map';
import UserConfig from '../config/User'

let searchFilters = {
  distance: 25,
  order: 'recent',
  photos: false,
  has_photo: false,
  online: false,
  age_min: UserConfig.minimumAge,
  age_max: UserConfig.maximumAge,
  height_min: UserConfig.minimumHeight,   // in cm
  height_max: UserConfig.maximumHeight,
  keywords: '',
  smoking: [],
  drinking: [],
  relationship_status: [],
  ethnicity: [],
  body_type: [],
  // unique trip params
  destination: [],
  leaving: '',
  leaving_dt: '',
  returning: '',
  returning_dt: '',
  who_pays: [],
  // main location.
  city: '',
  region: '',
  country: '',
  latitude: '',
  longitude: '',
  // departing from location.
  departing_from_city: '',
  departing_from_region: '',
  departing_from_country: '',
  departing_from_latitude: '',
  departing_from_longitude: '',
  departing_from_text: '',
};

let initialState = {
  filterMembersLivingIn: true,
  profile: [],
  trip: [],
  filters: searchFilters,
  defaultFilters: searchFilters,
  destinationPhoto: null,
  isFetching: false,

  // landing page for search:
  search_explore_members: [],
  search_upcoming_trips: [],
  search_people_near_me: [],
  search_top_destinations: []
};


const search = (state = initialState, action) => {
  switch(action.type) {
    case 'REQUEST_SEARCH':
      return {
        ...state,
        isFetching: true
      }

    case 'CLEAR_SEARCH':
      return {
        ...state,
        profile: [],
        trip: [],
        destinationPhoto: null,
        isFetching: false
      }

    case 'SAVE_FILTERS':
      return {
        ...state,
        filterMembersLivingIn: action.payload.filterMembersLivingIn,
        filters: { ...state.filters, ...action.payload.formData } // save search filters.
      }
      
    case 'RESET_FILTERS':
      return {
        ...state,
        filters: initialState.filters
      }

    case 'RESET_INDIVIDUAL_FILTER':
      let isDateReset = action.payload;
      // reset date or departing_from filters.
      let filtersThatReset = isDateReset ?
      {     leaving: '',
          leaving_dt: '',
          returning: '',
          returning_dt: '', } :
      { departing_from_city: '',
          departing_from_region: '',
          departing_from_country: '',
          departing_from_latitude: '',
          departing_from_longitude: '',
          departing_from_text: '' }

      return {
        ...state,
        filters: { ...state.filters, ...filtersThatReset }
      }
    case 'STORE_PROFILE_SEARCH':
      var oldProfiles = map(state.profile,(v)=>{return v; });
      let newProfiles = {...oldProfiles.concat(action.payload)};
      return {
        ...state,
        profile: newProfiles,
        isFetching: false
      };
    case 'STORE_TRIP_SEARCH':
      var oldTrips = map(state.trip,(v)=>{return v; });
      let newTrips = {...oldTrips.concat(action.payload)};
      return {
        ...state,
        trip: newTrips,
        isFetching: false
      };
    case 'TRIP_SEARCH_TRIP_JOIN':
      // someone joined a trip on search.
      // add/remove fav status
      var newLikeData = map(state.trip,(v)=>{return v; });
      // swap status
      let likeStatus = newLikeData[action.payload].is_liked;
      if(likeStatus == null) newLikeData[action.payload].is_liked = true;
      else newLikeData[action.payload].is_liked = null;
      return {...state, trip: newLikeData};

    case 'STORE_SEARCH_FAV_CHANGE':
      // add/remove fav status
      var newFavData = map(state.profile,(v)=>{return v; });
      // swap status
      let favStatus = newFavData[action.payload].account.data.is_favorite;
      if(favStatus == null) newFavData[action.payload].account.data.is_favorite = true;
      else newFavData[action.payload].account.data.is_favorite = null;
      return {...state, profile: newFavData};
    case 'STORE_FAV_CHANGE_HOME':
      // add/remove fav status
      var newExplore = map(state.search_explore_members,(v)=>{return v; });
      var newNearMe = map(state.search_people_near_me,(v)=>{return v; });
      newExplore.forEach((a,index) => {
        if(a.account.data.username === action.payload) {
          a.account.data.is_favorite ? 
          newExplore[index].account.data.is_favorite = null :
          newExplore[index].account.data.is_favorite = true;
        }
      });
      newNearMe.forEach((a,index) => {
        if(a.account.data.username === action.payload) {
          a.account.data.is_favorite ? 
          newNearMe[index].account.data.is_favorite = null :
          newNearMe[index].account.data.is_favorite = true;
        }
      });      
      return {...state, search_explore_members: newExplore, search_people_near_me: newNearMe};
    case 'STORE_TRIP_CHANGE_HOME':
      var newTrips = map(state.search_upcoming_trips,(v)=>{return v; });
      newTrips[action.payload].is_liked = true;
      return {...state, search_upcoming_trips: newTrips};
    case 'STORE_DESTINATION_PHOTO':
      return {
        ...state,
        destinationPhoto: action.payload
      }
    case 'STORE_SEARCH_INDEX_SECTION': 
      let newState = {
        ...state,
      }
      newState[action.payload.reducerKey] = action.payload.data;
      return newState;
    default:
      return state;
  }

}

export default search;



// WEBPACK FOOTER //
// ./src/reducers/search.js